module.exports = __webpack_public_path__ + "static/media/quicicon-04.5adf0f10.png";